{
  "settings": "Настройки",
  "yourDigitalAssistant": "Вашият цифров асистент",
  "getStarted": "Първи стъпки",
  "login": "Влизам",
  "loggingIn": "Влизане ...",
  "darkMode": "Тъмен режим",
  "clearHistory": "Чиста история",
  "historyCleared": "Историята е изчистена",
  "changeLanguage": "Език",
  "termsAndConditions": "Условия за ползване",
  "messagePlaceholder": "Напишете съобщението си тук ...",
  "messagePlaceholderDisabled": "Въвеждането е деактивирано ...",
  "feedbackTitle": "Оценете своя опит",
  "feedbackPlaceholder": "Разкажете ни за това (по избор)",
  "feedbackSend": "Изпрати",
  "feedbackClose": "Близо",
  "sessionExpired": "Сесията ви е изтекла поради неактивност.",
  "startNewSession": "Започнете нова сесия",
  "apiError": "Ами сега! Нещо се обърка. Работим по отстраняване на проблема, колкото е възможно по-скоро.",
  "apiErrorOffline": "Не сте свързани с интернет.",
  "tryAgain": "Опитай пак",
  "startOver": "Започни отначало",
  "chatEnded": "Чатът приключи.",
  "chatEndedThankYou": "Благодарим ви, че разговаряхте с нас!",
  "closeChat": "Близо",
  "startNewChat": "Чат отново",
  "humanTakeoverStarted": "Сега сте прехвърлени към обслужване на клиенти ...",
  "humanTakeoverQueued": "Изчаква се да се свърже с агент",
  "humanTakeoverAnAgent": "Агент",
  "humanTakeoverAgentEntered": "влезе в разговора",
  "humanTakeoverAgentLogout": "напусна разговора",
  "humanTakeoverTransfer": "Прехвърляте се към нов агент",
  "humanTakeoverEnded": "Вече разговаряте с вашия цифров асистент",
  "version": "Версия",
  "formIntroText": "Моля, попълнете следната форма, за да започнете да разговаряте с нас.",
  "formFirstName": "Първо име",
  "formLastName": "Фамилия",
  "formName": "Име",
  "formEmail": "електронна поща",
  "formWrongEmail": "Моля, посочете валиден имейл адрес.",
  "formPhone": "Телефон",
  "formShipmentId": "Идент. № на пратката",
  "formQuestion": "Твоят въпрос",
  "formAccountNumber": "Номер на сметката (за бизнес клиенти)",
  "formAddress": "адрес",
  "formPostcode": "пощенски код",
  "formCity": "град",
  "formCountry": "държава",
  "formSubmitButton": "Започнете чат",
  "formEmptyFieldError": "Не е позволено да бъде празно.",
  "formPhoneNumberValidationError": "Не е валиден телефонен номер.",
  "formInputIsBiggerThan50": "Трябва да съдържа най-много 50 знака.",
  "formInputIsBiggerThan100": "Трябва да съдържа най-много 100 знака.",
  "formInputIsBiggerThan2000": "Трябва да съдържа най-много 2000 знака.",
  "widgetEventOnline": "DA съобщение: Потребителят отново е онлайн.",
  "widgetEventHidden": "DA съобщение: Приспособлението е скрито.",
  "widgetEventVisible": "DA съобщение: Приспособлението е видимо.",
  "widgetEventVisibleMinimized": "DA съобщение: Приспособлението е видимо, но минимизирано.",
  "widgetEventMinimized": "DA съобщение: Приспособлението е сведено до минимум.",
  "widgetEventMaximized": "DA съобщение: Уиджетът е увеличен.",
  "widgetEventSessionExpired": "DA съобщение: Сесията на приспособленията е изтекла.",
  "widgetEventHangupHuman": "DA съобщение: Потребителят прекратява сесията за поглъщане от човека.",
  "widgetEventUserTyping": "DA съобщение: потребителят пише.",
  "fileTooLarge": "Опитвате се да прикачите твърде големи файлове.",
  "tooManyDiles": "Опитвате се да прикачите твърде много файлове.",
  "fileInvalidType": "Опитвате се да прикачите невалидни типове файлове.",
  "attachmentsDropHere": "Спуснете тук, за да качите или",
  "attachmentsBrowse": "Преглед на файлове",
  "attachmentsExtenstionQuantity": "pdf или изображения (до 10 файла)",
  "attachmentsSize": "до 30 MB",
  "attachmentsFailedUploading": "Качването не бе успешно",
  "attachmentsUploading": "Качва се ...",
  "minimizeExpandText": "Чат на живо с нас сега!",
  "popupWidgetNotificationMessage": "Получихте ново съобщение!",
  "tabWidgetNotificationMessage": "Ново съобщение!",
  "datepickerSendButton": "изпрати"
}
